import { PlusOutlined } from "@ant-design/icons";
import { Button, ButtonProps } from "antd";

interface CloneButtonProps extends ButtonProps {
  onClick?: () => void;
  title: string;
}

export function CloneButton({
  onClick,
  title,
  type,
  style,
}: Readonly<CloneButtonProps>) {
  return (
    <Button
      type={type}
      key="button"
      style={{
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: 20,
        ...style,
      }}
      icon={<PlusOutlined />}
      shape="round"
      size="large"
      onClick={onClick}
    >
      {title}
    </Button>
  );
}
